<template>
    <div class="banner0 tc white" :style="{ 'height': mobile ? '85vh' : '95vh'}" >
    <div class="w-100 " :style="{'height': mobile ? '95vh' : '75vh'}" :class="[ !mobile ? 'dt' : '' ]">
      <div class="w-60-ns w-100 dib" :class="[ !mobile ? 'dtc v-mid' : '' ]">
        <div class="pa2-ns tl w-90-ns w-100 center pa1 pt5-ns pt4 b f1" :class="[mobile ? 'tc' : 'header tl']" >Looking for insulation?</div>
        <div class="mt4-ns mt3 w-80-ns w-100 f2-ns f3">
          <div class="ph5-ns ph2 tl f2-ns f4 center" >
            <div class="">Homeowners/Contractors buy direct & save <span class="f1-ns f3 ph2 discount">20% off</span> on insulation products. </div>
            <div class="mt5-ns mt3">Call today for <span class="ph2 f1-ns f3 discount">next day delivery!</span></div>
          </div>
          <div class="pa2 mt3-ns mt4 tc center" ><a class="f3 br3 pa3 link call-button bg-yellow" :href="info.tel"><i class="fa fa-phone mr2" style="font-size:24px"/>{{info.phone}}</a></div>
        </div>
      </div>
      <transition name="slide-fade">
        <div v-if="load" class="w-40-ns w-100 dib" :class="[ !mobile ? 'dtc v-mid' : 'mt5' ]">
          <div class="center"><img class="insul-image w-100" src="../../assets/certainteed.png"/></div>
        </div> 
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Looking',
  props: ['info', 'mobile'],
  data: () => {
    return {
      load: false
    }
  },
  mounted: function() {
    this.load = true
  },
  components: {  }
}
</script>

<style scoped>
.banner0 {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7)), url("../../assets/house-banner.jpg");
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.insul-image {
  min-width: 350px;
}
.header {
  font-size: 3.5rem;
}

.discount {
  font-family: 'Gochi Hand', cursive;
  text-shadow: rgb(15,55,111) 3px 3px;
  color: gold;
}

.call-button {
  box-shadow: rgb(15,55,111) 5px 5px;
}
.call-button:hover {
  background: rgb(15, 55, 111);
  color: gold;
  box-shadow: gold 5px 5px;
  transition: .3s ease;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
</style>